import React, { Component } from "react";
import Imgloading from "./list/itemloading";
import logo from "../../assets/logo.png";

export default class Cart extends Component {
  handleCartClose = (close) => {
    this.props.HandleCartClose(close);
  };
  state = {
    fadeOut: false,
  };
  render() {
    return (
      <div
        className={` cart${this.props.Show ? " cart-show ani-stb" : ""}
       ${this.state.fadeOut ? "ani-stb-out" : ""}`}
      >
        <div className="cart-head">
          <div className="cart-head-close">
            <span
              onClick={() => {
                setTimeout(() => {
                  this.handleCartClose(false);
                }, 1000);
                this.setState({ fadeOut: true });

                setTimeout(() => {
                  this.setState({ fadeOut: false });
                }, 900);
              }}
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <svg
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.10156 11.6953L1.22656 0.0761719H5.04102L11 9.42773L17.2402 0.0761719H20.791L12.8809 11.6953L21.3008 24H17.416L10.9648 14.1211L4.33789 24H0.751953L9.10156 11.6953Z"
                  fill="white"
                />
              </svg>
            </span>
          </div>
        </div>

        <img src={logo} className="cart-logo0" alt="" />

        <h2 className="cart-head-title">
          {this.props.Language === "en"
            ? "My orders"
            : this.props.Language === "krd"
            ? "داخوازیێن تە"
            : "الطلبات"}
        </h2>

        {/*  */}

        {/*  */}
        <div className="cart-body-container">
          <div
            className={`cart-body 
            ${this.props.Cart.length ? "ani-gttb" : ""}`}
          >
            {this.props.Cart.length ? (
              <>
                {this.props.Cart.map((item, index) => {
                  return (
                    <div key={index} className="cart-item">
                      <div className="img">
                        <Imgloading Img={item.info.image} />
                      </div>

                      <div className="info">
                        <h3>
                          {this.props.Language == "en"
                            ? item.info.name_eng
                            : this.props.Language == "krd"
                            ? item.info.name_krd
                            : item.info.name_ar}
                        </h3>
                        <span>{item.info.price.toLocaleString()}</span>
                      </div>

                      <div className="action">
                        <i
                          className="fa-solid fa-plus"
                          onClick={() => this.props.updateCartItem(index, "+")}
                        ></i>
                        <p> {item.qty.toLocaleString()}</p>
                        <i
                          className="fa-solid fa-minus"
                          onClick={() => this.props.updateCartItem(index, "-")}
                        ></i>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <p>
                {this.props.Language === "en"
                  ? "There are no items in your list."
                  : this.props.Language === "krd"
                  ? "هیچ بابەتەک د لیستاتەدا نییە."
                  : "لا توجد عناصر في قائمتك."}
              </p>
            )}
          </div>
        </div>

        <div className="cart-footer">
          <div className="info">
            <div>
              {this.props.Language === "en"
                ? "Total"
                : this.props.Language === "krd"
                ? "کۆێ گشتی"
                : "المجموع"}
              : {this.props.SumPrice.toLocaleString()}
            </div>
            <div>
              {this.props.Language === "en"
                ? "Selected Item"
                : this.props.Language === "krd"
                ? "بابەتێن هەلبژارتی"
                : "العنصر المحدد"}
              ({this.props.SumQty.toLocaleString()})
            </div>
          </div>
          <div
            className="btn"
            onClick={() => {
              this.props.clearCartItem();
            }}
          >
            {this.props.Language === "en"
              ? "Clear"
              : this.props.Language === "krd"
              ? " ژێبرن"
              : "مسح"}
          </div>
        </div>
      </div>
    );
  }
}
